import React from 'react'

const VitalityBoxTable = () => {
  return (
      <div className="flex justify-center items-center">
                <div className="max-w-4xl w-full px-3 hidden md:block pt-6">
                  <div className="bg-[#233751] text-white text-center p-4 rounded-t-lg">
                    <h2 className="font-bold text-[24px] italic">
                      #2: The Vitality Box is a free 30-Day Trial.
                    </h2>
                  </div>

                  <div className="bg-[#EFF6FF] px-8 py-8 rounded-b-lg shadow-md border border-white text-gray-800 text-[20px] leading-relaxed text-start">
                    <p className="mb-4">
                      I designed this Vitality Box to give your body the daily
                      nourishment it needs at the cellular level.
                    </p>

                    <img
                      src="https://cdn.blackincae.com/D57-vitality-box-l-otto.png"
                      alt="Vitality Box"
                      className="float-right w-[311px] h-[190px] ml-2 mb-4"
                    />

                    <p className="mb-4">
                      It's nourishment your body NEEDS on an ongoing basis.
                    </p>
                    <p className="mb-4">
                      That's why The Vitality Box is a monthly subscription.
                    </p>
                    <p className="mb-4">
                      It will do you no long-term good as a "one and done."
                    </p>
                    <p className="mb-4">
                      So after your free 30-day trial, the Vitality Box will
                      renew at just $67 per month with FREE SHIPPING.
                    </p>
                    <p className="mb-4">
                      That way you'll continue to receive these health-boosting
                      formulations with zero worries and no fuss.
                    </p>
                    <p className="mb-4">
                      And don't worry, you can cancel anytime — no strings
                      attached.
                    </p>
                    <p>
                      But I'm confident that once you experience the energy,
                      clarity, and vitality you experience, you'll want it
                      delivered to your door every month.
                    </p>
                  </div>
                </div>

                <div className="flex justify-center items-center px-4 pt-6 block md:hidden">
                  <div className="max-w-4xl w-full md:px-6 px-0">
                    <div className="bg-[#233751] text-white text-center p-4 rounded-t-lg">
                      <h2 className="font-bold text-[24px] px-14">
                        #2: The Vitality Box is a free 30-Day Trial.
                      </h2>
                    </div>

                    <div
                      className="bg-[#EFF6FF] md:px-12 px-4 py-8 rounded-b-lg shadow-md flex flex-col md:flex-row relative border border-white"
                      style={{
                        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
                      }}
                    >
                      <div className="w-full md:w-1/2 flex justify-center md:order-none order-first mb-6 md:mb-0">
                        <img
                          src="https://cdn.blackincae.com/D57-vitality-box-l-otto.png"
                          alt="Vitality Box"
                          className="w-full h-full object-contain"
                        />
                      </div>

                      <div className="w-full md:w-1/2 pr-4 space-y-4 text-gray-800 text-start text-[20px]">
                        <p>
                          I designed this Vitality Box to give your body the
                          daily nourishment it needs at the cellular level.
                        </p>
                        <p>
                          It's nourishment your body NEEDS on an ongoing basis.
                        </p>
                        <p>
                          That's why The Vitality Box is a monthly subscription.
                        </p>
                        <p>
                          It will do you no long-term good as a "one and done."
                        </p>
                        <p>
                          So after your free 30-day trial, the Vitality Box will
                          renew at <br />
                          just $67 per month with FREE SHIPPING.
                        </p>
                        <p>
                          That way you'll continue to receive these
                          health-boosting formulations with zero worries and no
                          fuss.
                        </p>
                        <p>
                          And don't worry, you can cancel anytime — no strings
                          attached.
                        </p>
                        <p>
                          But I'm confident that once you experience the energy,
                          clarity, and vitality you experience, you'll want it
                          delivered to your door every month.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

  )
}

export default VitalityBoxTable